module.exports = __webpack_public_path__ + "static/media/amex.11860705.svg";